import { useState } from "react";

/**
 * TODO: Wire Contact Broker / Request Information to lead capture API when available.
 * Expected payload: canonicalPropertyId, source, listingType, title, price, requestType, message.
 */
const PropertyContactActions = ({ property }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [requestType, setRequestType] = useState("contact");

  const openModal = (type) => {
    setRequestType(type);
    setModalOpen(true);
  };

  const leadContext = {
    propertyId: property?.id,
    canonicalPropertyId: property?.canonicalListingId || property?.id,
    source: property?.primarySourceKey,
    listingType: property?.listingType || property?.transactionType,
    title: property?.title,
    price: property?.price ?? property?.priceMin,
    requestType,
  };

  return (
    <>
      <div className="property-detail-contact">
        <button
          type="button"
          className="midpoint-share-button midpoint-share-button--primary"
          onClick={() => openModal("contact")}
        >
          Contact broker
        </button>
        <button
          type="button"
          className="midpoint-share-button"
          onClick={() => openModal("info")}
        >
          Request information
        </button>
        <button
          type="button"
          className="midpoint-share-button midpoint-share-button--ghost"
          onClick={() => openModal("viewing")}
        >
          Schedule a viewing
        </button>
      </div>

      {modalOpen ? (
        <div
          className="property-detail-contact-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="property-contact-modal-title"
        >
          <div className="property-detail-contact-modal__backdrop" onClick={() => setModalOpen(false)} />
          <div className="property-detail-contact-modal__panel">
            <h3 id="property-contact-modal-title">Contact workflow coming soon</h3>
            <p>
              Lead capture for this listing will connect to broker outreach. Your request type:{" "}
              <strong>{requestType}</strong>.
            </p>
            <p className="intel-meta">
              Property: {leadContext.title || leadContext.canonicalPropertyId}
            </p>
            <button type="button" className="midpoint-share-button" onClick={() => setModalOpen(false)}>
              Close
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PropertyContactActions;
